import React from 'react';
import './Scolarite.css';

const Scolarite = () => {
  return (
    <section className="scolarite-section">
      <div className="scolarite-container">
        <div className="scolarite-logo">
          <img src="/photo/universiter/Dauphine_logo-removebg-preview.png" alt="Université Paris Dauphine" className="university-logo" />
        </div>
        <div className="scolarite-content">
          <h2 className="scolarite-title">Diplômé de la 1ère Université française</h2>
          <p className="scolarite-description">
            Un pied dans les maths de haut niveau, l'autre dans le code : diplômé en Math-Info, j'ai poussé ma compréhension jusqu'aux systèmes bas niveau et au Machine Learning. Toujours prêt à relever de nouveaux défis techniques !
          </p>
        </div>
      </div>
    </section>
  );
};

export default Scolarite;
